import { useContext } from 'react';

import { Context } from '../context';
import { useStore } from '../zustand/stores';

export const useIsSitePickerEnabled = () => {
  const { isMobile, isTablet } = useContext(Context);
  const { isAiServicesDisabled } = useStore((state) => state.featureTogglesSlice);

  if (isAiServicesDisabled || isMobile || isTablet) {
    return false;
  }

  return true;
};
